import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ArrowContainer } from "../../Components/CustomBox.js";
import { KPIBoxCustomWidth } from "../../Components/CustomBox";
import { Typography, Box, Grid2 } from "@mui/material";
import CustomIcon from "../../Components/CustomIcon.js";

function CarouselSlider({ disabled, position, onClick }) {
  return (
    <ArrowContainer
      disabled={disabled}
      onClick={onClick}
      left={position === "left" ? "-25px" : null}
      right={position === "right" ? "-25px" : null}
    >
      <CustomIcon
        name={
          position === "left"
            ? "chartCarouselPreviousArrow"
            : "chartCarouselNextArrow"
        }
        width={22}
        height={22}
        viewBox="0 0 22 22"
        fill="#828A92"
      />
    </ArrowContainer>
  );
}

const MultipleItems = ({
  Data,
  slidesToShow,
  setTheDate,
  actualDates,
  startDate,
}) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [activeSlide2, setActiveSlide2] = useState(0);
  const initialSlide = actualDates.findIndex((date) => date === startDate);
  const startIndexOfSlide =
    parseInt(initialSlide / slidesToShow) * slidesToShow;
  const [disablePreviousButton, setDisablePreviousButton] = useState(
    startIndexOfSlide === 0
  );
  const [disableNextButton, setDisableNextButton] = useState(
    startIndexOfSlide + slidesToShow >= actualDates.length
  );

  useEffect(() => {
    if (initialSlide >= 0 && initialSlide < Data.length) {
      sliderRef.current.slickGoTo(startIndexOfSlide);
    }
  }, [initialSlide, Data.length]);

  useEffect(() => {
    const startIndex = parseInt(activeSlide / slidesToShow) * slidesToShow;
    setDisablePreviousButton(startIndex === 0);
    setDisableNextButton(startIndex + slidesToShow >= actualDates.length);
  }, [activeSlide]);

  const sliderRef = React.createRef();

  var settings = {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: Data.length < slidesToShow ? Data.length : slidesToShow,
    slidesToScroll: Data.length < slidesToShow ? Data.length : slidesToShow,
    initialSlide: 0,
    beforeChange: (current, next) => setActiveSlide(next),
    afterChange: (current) => setActiveSlide2(current),
    centerMode: false,
    nextArrow: (
      <CarouselSlider position={"right"} disabled={disableNextButton} />
    ),
    prevArrow: (
      <CarouselSlider position={"left"} disabled={disablePreviousButton} />
    ),
  };

  return (
    <Box
      sx={{
        "& .slick-slide": {
          px: 1, // Equivalent to padding-left and padding-right of 8px
          boxSizing: "border-box",
        },
        "& .slick-list": {
          mx: -1, // Equivalent to margin-left and margin-right of -8px
        },
      }}
    >
      <Slider {...settings} ref={sliderRef}>
        {Data.map((slide, index) => (
          <div key={index} style={{ marginBottom: "10px", background: "red" }}>
            <KPIBoxCustomWidth
              onClick={() => {
                setTheDate(actualDates[index]);
              }}
              sx={{
                boxShadow:
                  actualDates[index] === startDate
                    ? "0px 4px 4px 0px rgba(151, 151, 151, 0.25)"
                    : "",
                bgcolor: "white",
                marginBottom: "10px",
                mt: 0,
                backgroundColor:
                  actualDates[index] === startDate ? "#F7F7FF" : "",
                border:
                  actualDates[index] === startDate
                    ? "2px solid #8F93FF"
                    : "2px solid #C8D1DA",
                "&:hover": {
                  border: "2px solid #8F93FF",
                },
              }}
            >
              <Grid2
                container
                gap={2}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Box>
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      lineHeight: "20px",
                      color:
                        actualDates[index] === startDate
                          ? "#444B51"
                          : "#828A92",
                    }}
                  >
                    {slide}
                  </Typography>
                </Box>
              </Grid2>
            </KPIBoxCustomWidth>
          </div>
        ))}
      </Slider>
    </Box>
  );
};

export default MultipleItems;
